import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormErrorEvents } from './list/types';

export const initialValues: FiltersFormErrorEvents = {
  typeEventCode: '',
  typeDestinationCode: '',
  subscriber: '',
  dateTimePublicationFrom: null,
  dateTimePublicationTo: null,
  state: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageEventsInErrorInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageEventsInErrorInitializer.displayName = 'Page events in error initializer component';

export default PageEventsInErrorInitializer;
